import { useEffect, useState } from "react";
import solution_img from '../../../Assets/image/solutionhead.659d55f19abad67967f.webp';
import homeImage from '../../../Assets/image/homei_11zon.webp';
import '../../../view/pages/solution/solution.css';
import Bar1 from "../../../components/navigationbar/navigationbar1";
import Card_Img from '../../../Assets/image/Card_img.webp';
import Animated_img from '../../../Assets/image/Animated_img.webp';
// import WindMill_img from '../../../Assets/image/Windmill_img.png';
import Animation from '../../../Assets/image/animation.webp';
import Grif1 from '../../../Assets/image/Windmill_gif.gif';
import Cornor_img from '../../../Assets/image/Cornor.webp';
import logo from "../../../Assets/image/logo.png";
import Footer from "../footer/footer";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const Solution = () => {

    ////////////////////////////scroll nav hide /////////////////
    const [isVisible, setIsVisible] = useState(true);
    const [lastScrollY, setLastScrollY] = useState(0);
    const handleScroll = () => {
        const currentScrollY = window.scrollY;
        if (currentScrollY > lastScrollY) {
            // Scrolling down
            setIsVisible(false);
        } else {
            // Scrolling up
            setIsVisible(true);
        }
        setLastScrollY(currentScrollY);
    };

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [lastScrollY]);

    ////////////////////////////scroll nav hide end /////////////////
    return (
        <>
            <Helmet>
                <title>Industrial & Solar Solutions | Sandip electronics  and Automation</title>
                <meta name="description" content="Custom automation solutions for agriculture and industry. From solar water pumping systems to automated power management and IoT-based monitoring." />
                <meta name="keywords" content="solar irrigation solutions, industrial power automation, automatic pump controllers, IoT agriculture India, energy efficient automation" />
                <meta property="og:title" content="Smart Automation Solutions by Sandip electronics " />
                <meta property="og:description" content="Bridging the gap between manual labor and smart technology. Explore our specialized solar and industrial solutions." />
                <meta property="og:image" content="https://seaiot.in/images/solutions-overview.jpg" />
                <meta property="og:url" content="https://seaiot.in/solution" />
                <meta property="og:type" content="website" />
            </Helmet>
            <div>
                <div className={`AppA ${isVisible ? "visible" : "hidden"}`}>
                    <div className="mylogo">
                        <div className="logo-container">
                            <Link to="/" className="cursor-pointer">
                                <img src={logo} alt="Logo" />
                            </Link>
                        </div>
                    </div>
                    <div className="bar-container">
                        <Bar1 />
                    </div>
                </div>

                <div>
                    <div className="main_div" >

                        <div class="grid grid-cols-12 p-2  pt-14 flex item-center align-items-center" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexWrap: 'wrap' }}>

                            <div class="col-span-12 sm:col-span-12 md:col-span-12 lg:col-span-6 item-center mt-10">
                                <div className="solution_img">
                                    <div className="hero-text-content">
                                        <h1 className="hero-title">Smart Solar Solutions</h1>
                                        <p className="hero-subtitle">Empowering your operations with cutting-edge IoT and automation technology</p>
                                        <div className="hero-buttons">
                                            <button className="btn-primary">Get Started</button>
                                            <button className="btn-secondary">Learn More</button>
                                        </div>
                                    </div>
                                    <div className="img">
                                        <img src={solution_img} alt="Solar Solution Technology" />
                                    </div>
                                </div>
                            </div>
                            <div class="col-span-12 sm:col-span-12 md:col-span-12 lg:col-span-6 item-center mt-10 flex justify-end">
                                <div className="home_image">
                                    <img src={homeImage} alt="Home" />
                                </div>
                            </div>
                        </div>
                        {/* Expertise Overview Section */}
                        <div className="expertise-section">
                            <div className="container">
                                <div className="section-header">
                                    <h2 className="section-title">
                                        Our expertise spans across multiple domains, ensuring seamless integration, automation, and efficiency for your operations.
                                    </h2>
                                    <div className="featured-badge">
                                        <div className="kswoff">
                                            <div class="blob"></div>
                                            <span>Wireless Remote Control & Monitor System (IoT) for Solar Pump Controller</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Features Grid Section */}
                        <div className="features-grid-section">
                            <div className="container">
                                <div className="features-header">
                                    <h2 className="features-title">🌟 Key Solutions We Offer</h2>
                                    <p className="features-subtitle">Comprehensive automation solutions tailored to your industry needs</p>
                                </div>
                                <div className="features-grid">
                                    <div className="feature-card">
                                        <div className="feature-icon">🤖</div>
                                        <h3>Smart Automation</h3>
                                        <p>Streamline your workflow with AI-driven automation, reducing manual effort and enhancing productivity.</p>
                                        <div className="feature-benefits">
                                            <span className="benefit">• 60% Time Reduction</span>
                                            <span className="benefit">• 99.9% Accuracy</span>
                                        </div>
                                    </div>
                                    <div className="feature-card">
                                        <div className="feature-icon">💻</div>
                                        <h3>Custom Software Development</h3>
                                        <p>Get tailor-made applications that align perfectly with your business goals and requirements.</p>
                                        <div className="feature-benefits">
                                            <span className="benefit">• Scalable Solutions</span>
                                            <span className="benefit">• Future-Ready</span>
                                        </div>
                                    </div>
                                    <div className="feature-card">
                                        <div className="feature-icon">📊</div>
                                        <h3>Real-Time Data Analytics</h3>
                                        <p>Gain deep insights with powerful analytics, helping you make informed decisions based on real-time data.</p>
                                        <div className="feature-benefits">
                                            <span className="benefit">• Live Monitoring</span>
                                            <span className="benefit">• Smart Insights</span>
                                        </div>
                                    </div>
                                    <div className="feature-card">
                                        <div className="feature-icon">🌐</div>
                                        <h3>IoT & Embedded Systems</h3>
                                        <p>Build intelligent, connected devices with our expertise in embedded technology and Internet of Things (IoT).</p>
                                        <div className="feature-benefits">
                                            <span className="benefit">• Remote Control</span>
                                            <span className="benefit">• Energy Efficient</span>
                                        </div>
                                    </div>
                                    <div className="feature-card">
                                        <div className="feature-icon">☁️</div>
                                        <h3>Cloud & Remote Management</h3>
                                        <p>Secure, scalable cloud solutions for remote monitoring, data storage, and infrastructure management.</p>
                                        <div className="feature-benefits">
                                            <span className="benefit">• 24/7 Access</span>
                                            <span className="benefit">• Secure Storage</span>
                                        </div>
                                    </div>
                                    <div className="feature-card">
                                        <div className="feature-icon">🔗</div>
                                        <h3>Seamless Integration</h3>
                                        <p>Our solutions integrate smoothly with your existing systems, ensuring minimal disruptions and maximum efficiency.</p>
                                        <div className="feature-benefits">
                                            <span className="benefit">• Zero Downtime</span>
                                            <span className="benefit">• Easy Setup</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>



                        {/* Solar Pump Solution Showcase */}
                        <div className="solar-showcase-section">
                            <div className="container">
                                <div className="showcase-content">
                                    <div className="showcase-image">
                                        <div className="image-wrapper">
                                            <img src={Card_Img} alt="Solar Water Pump System" />
                                            <div className="image-overlay">
                                                <div className="play-button">▶</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="showcase-info">
                                        <h2 className="showcase-title">Solar-Powered Water Pumping Systems</h2>
                                        <p className="showcase-description">
                                            Our solar-powered water pumps offer a sustainable and cost-effective solution
                                            for various water pumping needs, especially in areas with abundant sunlight.
                                            These systems utilize photovoltaic panels to convert sunlight into electricity,
                                            which powers the pump to draw water from sources such as wells, rivers, or lakes.
                                        </p>
                                        <div className="benefits-list">
                                            <div className="benefit-item">
                                                <span className="benefit-icon">🌱</span>
                                                <div>
                                                    <h4>Agricultural Irrigation</h4>
                                                    <p>Perfect for crop irrigation and greenhouse watering</p>
                                                </div>
                                            </div>
                                            <div className="benefit-item">
                                                <span className="benefit-icon">🐄</span>
                                                <div>
                                                    <h4>Livestock Watering</h4>
                                                    <p>Reliable water supply for cattle and farm animals</p>
                                                </div>
                                            </div>
                                            <div className="benefit-item">
                                                <span className="benefit-icon">🏠</span>
                                                <div>
                                                    <h4>Remote Water Supply</h4>
                                                    <p>Potable water access in remote locations</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="stats-row">
                                            <div className="stat">
                                                <span className="stat-number">50+</span>
                                                <span className="stat-label">Projects Completed</span>
                                            </div>
                                            <div className="stat">
                                                <span className="stat-number">95%</span>
                                                <span className="stat-label">Energy Savings</span>
                                            </div>
                                            <div className="stat">
                                                <span className="stat-number">24/7</span>
                                                <span className="stat-label">Monitoring</span>
                                            </div>
                                        </div>
                                        <button className="cta-button">Request Quote</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="animated_img mb-2 pb-2">
                            <img src={Animated_img} />
                        </div>

                    </div>

                    <div className="Images_content">
                        <div className="windmill_img">
                            <div className="windmill_container">
                                <div className="windmill_bg">
                                    <img className="grif" src={Grif1} alt="Wind Animation" />
                                    <img className="grif" src={Grif1} alt="Wind Animation" />
                                </div>
                                <div className="windmill_foreground">
                                    <img src={Animation} alt="Renewable Energy Animation" />
                                </div>
                            </div>
                        </div>
                        <div className='cornor_img'>
                            <img src={Cornor_img} alt="Decorative Element" />
                        </div>
                    </div>

                    {/* Testimonials Section */}
                    <div className="testimonials-section">
                        <div className="container">
                            <h2 className="section-title">What Our Clients Say</h2>
                            <div className="testimonials-grid">
                                <div className="testimonial-card">
                                    <div className="testimonial-content">
                                        <p>"The IoT solar pump system has revolutionized our irrigation process. We've seen a 70% reduction in operational costs and can monitor everything remotely."</p>
                                        <div className="testimonial-author">
                                            <strong>Rajesh Kumar</strong>
                                            <span>Farm Owner, Maharashtra</span>
                                        </div>
                                    </div>
                                    <div className="rating">⭐⭐⭐⭐⭐</div>
                                </div>
                                <div className="testimonial-card">
                                    <div className="testimonial-content">
                                        <p>"Excellent automation solutions! Their custom software perfectly fits our industrial needs. The real-time analytics have improved our efficiency tremendously."</p>
                                        <div className="testimonial-author">
                                            <strong>Priya Sharma</strong>
                                            <span>Operations Manager, Gujarat</span>
                                        </div>
                                    </div>
                                    <div className="rating">⭐⭐⭐⭐⭐</div>
                                </div>
                                <div className="testimonial-card">
                                    <div className="testimonial-content">
                                        <p>"The seamless integration and 24/7 support make them our go-to technology partner. Highly recommend for any automation needs."</p>
                                        <div className="testimonial-author">
                                            <strong>Amit Patel</strong>
                                            <span>CEO, Tech Solutions</span>
                                        </div>
                                    </div>
                                    <div className="rating">⭐⭐⭐⭐⭐</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* FAQ Section */}
                    <div className="faq-section">
                        <div className="container">
                            <h2 className="section-title">Frequently Asked Questions</h2>
                            <div className="faq-grid">
                                <div className="faq-item">
                                    <h3 className="faq-question">How long does installation take?</h3>
                                    <p className="faq-answer">Typically 2-5 days depending on system complexity. We provide detailed timeline during consultation.</p>
                                </div>
                                <div className="faq-item">
                                    <h3 className="faq-question">What maintenance is required?</h3>
                                    <p className="faq-answer">Minimal maintenance required. Our systems are designed for durability with optional maintenance contracts.</p>
                                </div>
                                <div className="faq-item">
                                    <h3 className="faq-question">Do you provide remote monitoring?</h3>
                                    <p className="faq-answer">Yes, all our IoT solutions include 24/7 remote monitoring with real-time alerts and analytics.</p>
                                </div>
                                <div className="faq-item">
                                    <h3 className="faq-question">What's the warranty period?</h3>
                                    <p className="faq-answer">We offer 3-5 years warranty on hardware and lifetime support on software solutions.</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Call to Action Section */}
                    <div className="cta-section">
                        <div className="container">
                            <div className="cta-content">
                                <h2>Ready to Transform Your Operations?</h2>
                                <p>Get started with our expert consultation and discover the perfect automation solution for your needs.</p>
                                <div className="cta-buttons">
                                    <button className="btn-primary large">Schedule Consultation</button>
                                    <button className="btn-secondary large">Download Brochure</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />

        </>
    );
};

export default Solution;
